<div class="user-in-main">
    <div class="left-block">
        <button (click)="siteNavigate()" class="button-medium back-to-website-btn" color="dark" mat-button
                mat-stroked-button title="Countable.co">
                <span class="flexbox-row gap-8">
                    <i class="fa-regular fa-house"></i>
                    <span class="button-label">Back To Website</span>
                </span>
        </button>
        <ng-image-slider #nav [animationSpeed]="0.8" [autoSlide]="3" [imagePopup]="false" [imageSize]="{width: '100%', height: '100%'}"
                         [images]="imgCollection" [infinite]="true" class="slider"
                         slideImage="1"></ng-image-slider>
        <a class="support-link text-white" href="mailto:support@countable.co" title="support@countable.co">support&#64;countable.co</a>
    </div>
    <div class="right-block">
        <div class="content-block br-12 bg-white">
            <div class="brand align-self-center mb-32">
                <img alt="Countable" src="/assets/images/global/brand-primary.svg"/>
            </div>
            <div class="d-flex flex-column" [ngClass]="{'success-content':isSetPasswordSuccess}">
                <ng-container *ngIf="!isSetPasswordSuccess">
                    <h3 class="title align-self-center mb-32">Set Password</h3>
                    <form [formGroup]="setPasswordForm" autocomplete="off">
                        <div class="form-group">
                            <mat-form-field class="fixed-label w-100" floatLabel="always">
                                <mat-label>Email</mat-label>
                                <input [disabled]="true" formControlName="email" matInput placeholder="Email"
                                       placeholder="Email" required>
                            </mat-form-field>
                            <mat-form-field class="fixed-label icon-field-after w-100" floatLabel="always">
                                <mat-label>Password</mat-label>
                                <input (input)="checkPassword($event);"
                                       type="{{showPassword ? 'text' : 'password'}}"
                                       autocomplete="new-password" formControlName="password" matInput maxlength="200"
                                       name="password" placeholder="Password" required tabindex="2">
                                       <span matSuffix>
                                           <button mat-button class="button-text" (click)="changeShowPassword()">
                                               <i class="fa-regular"[ngClass]="(!showPassword ? 'fa-eye-slash' : 'fa-eye')"></i>
                                           </button>
                                       </span>
                            </mat-form-field>
                            <div *ngIf="!passwordEntity.isValid" class="text-gray-5 d-flex flex-column gap-2">
                                <h6 class="title">Password must:</h6>
                                <p *ngIf="!passwordEntity.isLengthValid"
                                   [ngClass]="{'valid': passwordEntity.isLengthValid }">
                                    Have at least 8 characters</p>
                                <p *ngIf="!passwordEntity.hasAlphabet"
                                   [ngClass]="{'valid': passwordEntity.hasAlphabet}">
                                    Have at least 1 letter (a, b, c...)</p>
                                <p *ngIf="!passwordEntity.hasNumber"
                                   [ngClass]="{'valid': passwordEntity.hasNumber }">
                                    Have at least 1 number (1, 2, 3...)</p>
                                <p *ngIf="!passwordEntity.hasEspecialChar"
                                   [ngClass]="{'valid': passwordEntity.hasEspecialChar}">
                                    Have at least 1 special character</p>
                                <p *ngIf="!passwordEntity.hasUpperLowerCase"
                                   [ngClass]="{'valid': passwordEntity.hasUpperLowerCase}">
                                    Include both upper case and lower Case</p>
                            </div>
                            <mat-form-field class="fixed-label icon-field-after w-100" floatLabel="always">
                                <mat-label>Re-enter Password</mat-label>
                                <input (input)="enableSubmitButton()"
                                       [errorStateMatcher]="matcher"
                                       autocomplete="new-password"
                                       type="{{showPassword ? 'text' : 'password'}}"
                                       formControlName="confirmPassword" matInput
                                       maxlength="200"
                                       name="confirmPassword" placeholder="Re-enter Password" required
                                       tabindex="3">
                                       <span matSuffix>
                                           <button mat-button class="button-text" (click)="changeShowPassword()">
                                               <i class="fa-regular"[ngClass]="(!showPassword ? 'fa-eye-slash' : 'fa-eye')"></i>
                                           </button>
                                       </span>
                                <span *ngIf="setPasswordForm.hasError('notSame') && (setPasswordForm.get('confirmPassword').dirty || setPasswordForm.get('confirmPassword').touched)"
                                      class="error-message">
                                Password doesn't match
                            </span>
                            </mat-form-field>
                        </div>
                        <div class="d-flex gap-10 mt-20">
                            <mat-checkbox (change)="enableSubmitButton()" [(ngModel)]="agreedToPolicy"
                                          [ngModelOptions]="{standalone: true}"
                                          class="gray-checkbox"
                                          tabindex="4">
                                I agree to the <button (click)="openTermsPrivacyDialog('terms-of-Use')" class="text-link"
                                                 title="Terms of Use"> Terms of Use</button>
                                & <button (click)="openTermsPrivacyDialog('privacy-policy')" class="text-link"
                                     title="Privacy Policy">Privacy Policy</button>
                            </mat-checkbox>
                        </div>
                        <button (click)="setPassword()" [disabled]="!isSetPasswordEnabled" class="mt-4 w-100 btn-normal mb-32" color="primary" mat-button
                                mat-flat-button
                                tabindex="5" title="Set Password" type="button"> Set Password
                        </button>
                    </form>
                    <p class="mb-32 mt-4 fs-14 text-center text-gray-5">Already have an account? <a class="text-link"
                                                                                                    routerLink="/login"
                                                                                                    title="Login">Login</a>
                    </p>
                </ng-container>
                <ng-container *ngIf="isSetPasswordSuccess">
                    <span class="icon-outer mb-lg-4 mb-3 mx-auto bg-success-1">
                        <svg fill="none" height="17.5" viewBox="0 0 17 15" width="20"
                             xmlns="http://www.w3.org/2000/svg">
                          <path clip-rule="evenodd" d="M14.7953 0.853403L5.24867 10.0667L2.71534 7.36007C2.24867 6.92007 1.51534 6.8934 0.982005 7.26674C0.462005 7.6534 0.315338 8.3334 0.635338 8.88007L3.63534 13.7601C3.92867 14.2134 4.43534 14.4934 5.00867 14.4934C5.55534 14.4934 6.07534 14.2134 6.36867 13.7601C6.84867 13.1334 16.0087 2.2134 16.0087 2.2134C17.2087 0.986737 15.7553 -0.093263 14.7953 0.84007V0.853403Z"
                                fill="#37A77C"
                                fill-rule="evenodd"/>
                          </svg>
                      </span>
                    <h4 class="title" class="title mb-lg-4 mb-3 text-center">Password Set Successfully</h4>
                    <button [routerLink]="['/login']" class="btn-normal w-100 mb-lg-4 mb-3" color="primary" mat-button
                            mat-flat-button>Login Now
                    </button>
                    <div class="terms mt-4">
                        <div role="list" class="items-list bottom-nav">
                            <button (click)="openTermsPrivacyDialog('privacy-policy')" class="bottom-nav-item text-link fs-14"
                               title="Privacy Policy">Privacy Policy</button>
                            <button (click)="openTermsPrivacyDialog('terms-of-Use')" class="bottom-nav-item text-link fs-14"
                                title="Terms of Use & Privacy Policy">Terms
                                of Use</button>
                        </div>
                    </div>
                </ng-container>
            </div>
        </div>
    </div>
</div>
